import React from "react"
import { Global } from "@emotion/react"
import tw, { css, GlobalStyles as BaseStyles, theme } from "twin.macro"
import "@splidejs/react-splide/css"

const customStyles = css`
    @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap");

    body {
        ${tw`antialiased`};
        font-family:
            Inter,
            -apple-system,
            BlinkMacSystemFont,
            "sans-serif";
    }

    /* AntD Tooltip */
    .ant-tooltip .ant-tooltip-arrow:before,
    .ant-tooltip .ant-tooltip-inner {
        font-size: 12px;
        font-weight: 400;
    }

    /* AntD Notification */
    .ant-notification {
        .ant-notification-notice-wrapper {
            border-radius: 4px;
            box-shadow: ${theme`boxShadow.md`};

            .ant-notification-notice {
                padding: 8px;
                border-radius: inherit;
            }
        }

        .ant-notification-notice-message {
            display: none;
        }
        .ant-notification-notice-description {
            display: flex;
            gap: 8px;
        }

        .alert-success {
            border: 1px solid ${theme`colors.teal800`};
            background-color: ${theme`colors.teal200`};

            .ant-notification-notice-description {
                color: ${theme`colors.teal800`};
            }
        }

        .alert-error {
            border: 1px solid ${theme`colors.red600`};
            background-color: ${theme`colors.red200`};

            .ant-notification-notice-description {
                color: ${theme`colors.red600`};
            }
        }
    }

    /* AntD Button */
    .ant-btn.ant-btn-primary:disabled {
        color: ${theme`colors.white`};
        border-color: ${theme`colors.primary_disabled`};
        background-color: ${theme`colors.primary_disabled`};
    }

    /* AntD Radio */
    .ant-radio-wrapper {
        .ant-radio-inner {
            border-color: ${theme`colors.gray500`};
            border-width: 2px;
        }

        &.ant-radio-wrapper-checked .ant-radio-inner {
            background-color: ${theme`colors.white`};
            border-width: 2px;

            &::after {
                transform: scale(0.5);
                background-color: ${theme`colors.primary`};
            }
        }
    }

    /* Dropdown */

    .ant-dropdown-menu-item.ant-dropdown-menu-item-active {
        &.color-red {
            color: ${theme`colors.red600`} !important;
            .atomic-icon {
                color: ${theme`colors.red600`} !important;
            }
        }
    }
`

const GlobalStyles = () => (
    <>
        <BaseStyles />
        <Global styles={customStyles} />
    </>
)

export default GlobalStyles
